var _defs, _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f7931a;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 80,
    height: 80,
    rx: 16,
    ry: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.89,49.37c-2.39,2.39-2.39,6.26,0,8.64,2.39,2.39,6.26,2.39,8.64,0,2.39-2.39,2.39-6.26,0-8.64-2.39-2.39-6.26-2.39-8.64,0Zm7.81,7.81c-1.93,1.93-5.05,1.93-6.98,0-1.93-1.93-1.93-5.06,0-6.98,1.93-1.93,5.05-1.93,6.98,0,1.93,1.93,1.93,5.06,0,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.6,58.03c-2.39,2.39-2.39,6.27,0,8.66,2.39,2.39,6.26,2.39,8.65,0,2.39-2.39,2.39-6.27,0-8.66-2.39-2.39-6.26-2.39-8.65,0Zm7.82,7.82c-1.93,1.93-5.06,1.93-6.99,0-1.93-1.93-1.93-5.06,0-6.99,1.93-1.93,5.06-1.93,6.99,0,1.93,1.93,1.93,5.06,0,6.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.44,49.37c-2.39,2.39-2.39,6.26,0,8.64,2.39,2.39,6.26,2.39,8.64,0,2.39-2.39,2.39-6.26,0-8.64-2.39-2.39-6.26-2.39-8.64,0Zm7.81,7.81c-1.93,1.93-5.06,1.93-6.98,0-1.93-1.93-1.93-5.06,0-6.98,1.93-1.93,5.06-1.93,6.98,0,1.93,1.93,1.93,5.06,0,6.98Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.76,
    cy: 53.69,
    r: 2.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.92,
    cy: 62.36,
    r: 2.93,
    transform: "translate(-22.69 101.88) rotate(-89.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.22,
    cy: 53.69,
    r: 2.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.03,
    cy: 45.87,
    r: 2.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.57,
    cy: 45.87,
    r: 2.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.92,
    cy: 50.94,
    r: 2.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.08,42c5.57-5.57,5.57-14.6,0-20.17-5.57-5.57-14.6-5.57-20.17,0-5.57,5.57-5.57,14.6,0,20.17,5.57,5.57,14.6,5.57,20.17,0Zm-18.88-18.88c4.86-4.86,12.73-4.86,17.58,0,4.86,4.85,4.86,12.73,0,17.58-4.86,4.86-12.73,4.86-17.58,0-4.86-4.86-4.86-12.73,0-17.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40,
    cy: 31.92,
    r: 10.76,
    transform: "translate(2.09 66.29) rotate(-80.78)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.47,31.05c-.63-1.5-2.35-2.22-3.87-1.61l-3.5,1.4c-.31.12-.67.01-.84-.28-.2-.35-.03-.79.33-.93l5.06-2.03c1.2-.48,1.78-1.84,1.3-3.04h0s-10.99,4.41-10.99,4.41c-.1.04-.17.12-.21.21-.04.09-.04.18-.01.28.07.21.32.31.53.23l2.67-1.07c.19-.08.42,0,.51.18.05.11.05.23,0,.33-.04.09-.11.17-.21.21l-2.16.87c-.1.04-.17.12-.21.21-.04.09-.04.18-.01.28.07.21.32.31.53.23l.49-.2h0c.33-.12.69.05.83.38.07.17.06.35,0,.5-.06.15-.18.27-.33.34l-5.42,2.18c-.1.04-.17.12-.21.21-.04.09-.04.18-.01.28.07.21.32.31.53.23l6.21-2.49c.19-.08.42,0,.51.18.05.11.05.23,0,.33-.04.09-.11.16-.2.2h0s-3.32,1.33-3.32,1.33c-.1.04-.17.12-.21.21-.04.09-.04.2,0,.3.08.2.31.3.51.22l8.71-3.5c.36-.15.78.06.88.45.08.32-.1.66-.41.78l-7.3,2.93c-.1.04-.17.12-.21.21-.04.1-.04.22,0,.33.09.18.32.26.51.18l1.05-.42c.19-.08.42,0,.51.18.05.11.05.22,0,.32-.04.09-.11.17-.21.21l-2.67,1.07c-.1.04-.17.12-.21.21-.04.1-.04.22,0,.33.09.18.32.26.51.18l8.84-3.55c1.56-.63,2.35-2.42,1.7-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m36.13,36.68c.04-.09.04-.19.01-.28-.07-.21-.32-.31-.53-.23l-1.45.58c-.1.04-.17.12-.21.21-.04.1-.04.22.01.33.09.18.32.26.51.18l1.45-.58c.1-.04.17-.12.21-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.15,32.22l1.95-.78c.1-.04.17-.12.21-.21.04-.09.04-.18.01-.28-.07-.21-.32-.31-.53-.23l-1.95.78c-.1.04-.17.12-.21.21-.04.09-.04.18-.01.28.07.21.32.31.53.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocation);
export default __webpack_public_path__ + "static/media/allocation.cd2125728efa086876ad8e443eed31a9.svg";
export { ForwardRef as ReactComponent };